import React from 'react';
import Icon from 'shared/components/icon';
import TextButton from 'src/components/text-button';
import {useDispatch, useSelector} from 'react-redux';
import req from 'shared/req';
import {getFollowedCollegesNextTransferTerms} from '../colleges-not-offering-transfer-term-modal/actions';
import {openModal} from 'shared/actions/modal';
import {COLLEGES_NOT_OFFERING_TRANSFER_TERM_MODAL} from '../colleges-not-offering-transfer-term-modal/colleges-not-offering-transfer-term-modal';
import {Store} from 'src/types/store';
import {filter} from 'lodash';

export const DISMISS_MESSAGE = 'DISMISS_MESSAGE';

const TermsBannerMessage = () => {
  const dispatch = useDispatch();

  const student = useSelector((state: Store) => state.student);
  const termsBannerMessages = useSelector((state: Store) => state.termsBannerMessages);
  const showTransferEducationDeadlineMessage = useSelector(
    (state: Store) => state.showTransferEducationDeadlineMessage
  );

  const transferTerm = student.communityCollegeInfo?.transferSemester?.toLowerCase() ?? '';

  const openCollegesNotOfferingModal = () => {
    openCollegesNotOfferingTransferTermModal(transferTerm);
  };

  const notOfferedCollegeTransferTerms = filter(
    student.followedCollegesNextTransferTerms,
    (college) => college?.transferTerm !== transferTerm
  ).length;

  const show =
    showTransferEducationDeadlineMessage &&
    termsBannerMessages.dismissed === false &&
    notOfferedCollegeTransferTerms > 0;

  const studentId = student._id;

  const dismissMessageFeatureInteraction = () => () => {
    const url = `/v1/users/${studentId}/feature-interactions/transfer-education-deadline-message`;
    const date = new Date();
    req({
      url,
      method: 'put',
      data: {featureData: {dismissed: true, timestamp: date}},
    });
  };

  const dismissMessage = () => ({
    type: DISMISS_MESSAGE,
  });

  const dismiss = () => {
    dispatch(dismissMessageFeatureInteraction());
    dispatch(dismissMessage());
  };

  const openCollegesNotOfferingTransferTermModal = (term) => {
    dispatch(getFollowedCollegesNextTransferTerms(term));
    dispatch(openModal(COLLEGES_NOT_OFFERING_TRANSFER_TERM_MODAL));
  };

  if (!show) {
    return null;
  }

  return (
    <div className="portfolio-banner-message">
      <i className="rm rm-exclamation-triangle-r exclamation"></i>
      {notOfferedCollegeTransferTerms} followed colleges do not offer your Planned Transfer Term.
      <TextButton className="view-college" onClick={openCollegesNotOfferingModal} margin={false}>
        View college
      </TextButton>
      <button
        className="close-banner"
        type="button"
        aria-label="Dismiss course walk through"
        onClick={() => {
          dismiss();
        }}
      >
        <Icon iconType="times-r" />
      </button>
    </div>
  );
};

export default TermsBannerMessage;
